export class ObservationStatusDescription {
	nl:string = "";
	fr:string = "";
	de:string = "";

	public constructor(data:any){
		this.nl = data.nl;
		this.fr = data.fr;
		this.de = data.de;
	}

	getText(selectedLang:string):string{
		if (selectedLang == "nl-be") {
			selectedLang = "nl";
		}
		return (this as any)[selectedLang] || this.nl;
	}
}